import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { AddressInput } from '~/components/component-library'
import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { addressSchema } from '~/components/smart-accounts/schemas'
import { useServerRequests } from '~/hooks/useRequests'

const addClankerTrackedTokenSchema = z.object({
  tokenAddress: addressSchema,
})

export const AddClankerTrackedTokenDialog = ({
  requestPath,
  title,
  onClose,
  onSuccess,
}: {
  requestPath: string
  title: string
  onClose: () => void
  onSuccess?: () => void
}) => {
  const {
    control,
    handleSubmit,
    formState,
    setValue,
    setError,
    clearErrors,
    trigger,
  } = useForm({
    resolver: zodResolver(addClankerTrackedTokenSchema),
    defaultValues: {
      tokenAddress: '',
    },
    mode: 'onChange',
  })

  const { serverPostRequest, isProcessing } = useServerRequests()
  const onSubmit = handleSubmit(async (data) => {
    const response = await serverPostRequest({
      path: requestPath,
      params: {
        tokenAddress: data.tokenAddress,
      },
      errorMessage: 'Failed to add Clanker token',
      successMessage: 'Clanker token added',
    })

    if (response) {
      onSuccess?.()
      onClose()
    }
  })

  return (
    <SplitsDialogContent
      id="addClankerTrackedTokenForm"
      title={title}
      variant="confirmation"
      isLoading={isProcessing}
      confirmButton={{
        text: 'Add token',
        isDisabled: !formState.isValid || isProcessing,
        onClick: onSubmit,
      }}
    >
      <div className="text-sm text-secondary">
        Add a token contract to track Clanker rewards. Available rewards will
        appear in positions.
      </div>
      <form onSubmit={onSubmit}>
        <AddressInput
          control={control}
          inputName="tokenAddress"
          label="Token address"
          placeholder="0x..."
          setValue={setValue}
          setError={setError}
          clearErrors={clearErrors}
          trigger={trigger}
        />
      </form>
    </SplitsDialogContent>
  )
}
